/**
 * Template Analytics Service
 *
 * API client for marketplace analytics endpoints.
 */
import api from './api';
import { TemplateAnalyticsResponse, AuthorAnalyticsResponse } from '../types/template-analytics';

export const templateAnalyticsService = {
  /**
   * Get analytics for a specific template.
   */
  getTemplateAnalytics: async (
    templateId: string,
    days: number = 30
  ): Promise<TemplateAnalyticsResponse> => {
    const response = await api.get(`/marketplace/analytics/templates/${templateId}`, {
      params: { days },
    });
    return response.data;
  },

  /**
   * Get analytics for the current user's templates.
   */
  getAuthorAnalytics: async (days: number = 30): Promise<AuthorAnalyticsResponse> => {
    const response = await api.get('/marketplace/analytics/author', {
      params: { days },
    });
    return response.data;
  },
};
